import { PersonEntity } from "../Person/PersonEntity"
import { BaseModel } from "../Generics/BaseModel"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"

export class Employee extends BaseModel {
  id: string

  employeeId: number

  password: string

  salaryFixed: string

  percentCommission: string

  userName: string

  iconUrl: string

  isMaster: boolean

  hasCompletedOwnerOnboarding: boolean

  hasCompletedModuleSetup: boolean

  isDeliveryEmployee: boolean

  companyFunction: string

  personEntity: PersonEntity

  status: EEnableStatusType

  permissions: string[]

  constructor(data: Partial<Employee> = {}) {
    super()

    this.id = data.id ?? ""

    this.employeeId = data.employeeId ?? -1

    this.isDeliveryEmployee = data.isDeliveryEmployee ?? false

    this.status = data.status ?? EEnableStatusType.Active

    this.password = data.password ?? ""

    this.salaryFixed = data.salaryFixed ?? "0.0"

    this.percentCommission = data.percentCommission ?? "0"

    this.iconUrl = data.iconUrl ?? ""

    this.isMaster = data.isMaster ?? false

    this.hasCompletedOwnerOnboarding = data.hasCompletedOwnerOnboarding ?? false

    this.hasCompletedModuleSetup = data.hasCompletedModuleSetup ?? false

    this.companyFunction = data.companyFunction ?? ""

    this.personEntity = new PersonEntity(data.personEntity)

    this.permissions = data.permissions ?? []

    this.userName = data.userName ?? ""
  }
}
